import * as Services from "../../Service/Service"
import * as Url from '../../Service/Url';

export const getCarrier = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CARRIER, token)
  return res;
};

export const createUpdateCarrier = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_CARRIER, payload, token)
  return res;
};


export const deleteCarrier = async(carrierId) => {
  const token = localStorage.getItem("token");
  const params = {
    CarrierID: carrierId,
  };
  let res = await Services.DELETE(Url.DELETE_CARRIER+carrierId, params, token)
  return res;
};
